import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditAcademicTerm from '../../components/academicTerms/FormAddEditAcademicTerm';

const CreateAcademicTerm = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <FormAddEditAcademicTerm />
    </WrapperSection>
);

export default CreateAcademicTerm;
